<template>
  <div>
    <v-layout row wrap pt-2>
      <v-flex sm12>
        <!-- {{category}} -->
        <v-layout row wrap v-if="url == '/products'">
          <v-flex md4 pb-4 v-for="product in list" :key="product.id">
            <product-card :product="product" />
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex md6 pr-4 pb-4 v-for="product in list" :key="product.id">
            <product-user-card :product="product"/>
          </v-flex>
      </v-layout>
      </v-flex>
    </v-layout>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="spinner">Cargando...</div>
      <div slot="no-more" style="visibility: hidden">No hay más resultados</div>
      <v-layout slot="no-results">
        <v-flex sm12>
          <v-card height="400px">
            <v-layout align-center justify-center row wrap fill-height>
              <v-flex
                sm12
                class="text-29-security text-md-center font-weight-bold"
                style="color: #525252"
              >No hay avisos clasificados de esta categoría</v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </infinite-loading>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import ProductCard from "./ProductCard";
import ProductUserCard from "./ProductUserCard";
import config from "@/config";
export default {
  components: {
    ProductCard,
    ProductUserCard
  },
  props: {
    category: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      page: 1,
      list: []
    };
  },
  methods: {
    ...mapMutations("products", ["setProduct", "setProducts"]),
    infiniteHandler($state) {
      let api = `${process.env.VUE_APP_API_URL + this.url}`;
      let view_as = localStorage.getItem("view_as") || null
      axios
        .get(api, { params: { page: this.page, category: this.category, view_as: view_as } })
        .then(({ data }) => {
          if (data.hits.length) {
            this.page += 1;
            this.list.push(...data.hits);
            this.setProducts(this.list);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    },
    goToShowProduct(id) {
      this.$router.push({
        name: "product-show",
        params: { id: id, myProduct: true }
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>

<style>
</style>